import { Command, Option } from '@commander-js/extra-typings';
import { Publisher } from '@docmaps/sdk';
import { isLeft, right } from 'fp-ts/lib/Either';
import { process as proc } from './processor';
import * as crossref from './plugins/crossref';
import { CrossrefPlugin } from './plugins/crossref';
const stdoutWrite = (str) => process.stdout.write(str);
export function MakeCli() {
    const cli = new Command();
    cli
        .name('docmaps-cli')
        .description('Command line utility for paginated/streamed creation of docmaps from similar data')
        .version('0.1.0');
    const PLUGINOPTIONS = ['crossref-api'];
    cli
        .command('item')
        .description('create docmap for a single doi based on chosen source')
        .argument('<doi>', 'doi to search and analyze for docmap creation')
        .addOption(new Option('--source <plugin>', `the plugin source name`)
        .preset(PLUGINOPTIONS[0])
        .choices(PLUGINOPTIONS)
        .makeOptionMandatory())
        .option('--source.crossrefApi.politeMailto <email>', 'email for crossref api polite label (your email)')
        .option('--publisher.id <id>', 'id of publisher of docmaps to generate (you)')
        .option('--publisher.name <name>', 'name of publisher of docmaps to generate (you)')
        .option('--publisher.url <url>', 'url of publisher of docmaps to generate (you)')
        .option('--publisher.homepage <homepage>', 'homepage of publisher of docmaps to generate (you)')
        .option('--publisher.logo <logo>', 'logo of publisher of docmaps to generate (you)')
        .action(async (doi, options) => {
        const pub = Publisher.decode({
            id: options['publisher.id'],
            name: options['publisher.name'],
            homepage: options['publisher.homepage'],
            url: options['publisher.url'],
            logo: options['publisher.logo'],
        });
        if (isLeft(pub)) {
            cli.error(String(pub.left));
            throw 'unreachable, if cli.error exits (?)';
        }
        const politeMailto = options['source.crossrefApi.politeMailto'];
        const crossrefConfig = politeMailto
            ? {
                politeMailto,
            }
            : {};
        const o = {
            source: {
                preset: options.source,
                client: crossref.CreateCrossrefClient(crossrefConfig),
            },
            publisher: pub.right,
        };
        const result = await ItemCmd([doi], o);
        if (isLeft(result)) {
            cli.error(String(result.left));
            throw 'unreachable, if cli.error exits (?)';
        }
        const out = JSON.stringify(result.right);
        const writer = cli.configureOutput()?.writeOut || stdoutWrite;
        writer(out);
    });
    return cli;
}
export const ItemCmd = ([doi], opts) => {
    const plugin = CrossrefPlugin(opts.source.client);
    return proc(plugin, opts.publisher, doi);
};
export const PageCmd = async (_a, _opts) => {
    return right([]);
};
const cli = MakeCli();
export default cli;
//# sourceMappingURL=command.js.map